import { render } from "./token-pagination.vue?vue&type=template&id=5510b88a&ts=true"
import script from "./token-pagination.ts?vue&type=script&lang=ts"
export * from "./token-pagination.ts?vue&type=script&lang=ts"

import "./token-pagination.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__